// extracted by mini-css-extract-plugin
module.exports = {"flash-borrow-amount":"flash-borrow-amount-6c70e41c76572c397ae2215be03f1d4c"};